<template>
	<div class="link-work">
		<div class="all-box">
			<tpl-detail titName="培训作业">
				<template slot="titRight">
					<el-input
						placeholder="请输入内容"
						v-model="searchKeyWord"
						style="width:180px"
						clearable
						size="small"
					>
					<el-button slot="append" type="primary" class="search-btn" size="small" @click="selectData">搜索</el-button>
					</el-input>

				</template>
				<template slot="body">
					<div class="do-box clearfix">
						<el-button v-if="isAdmin" class="fr" type="primary" size="small" @click="evaPop">一键评价</el-button>
						<el-button v-if="isAdmin" class="fr" type="primary" size="small" @click="downlaodExecl">导出分数</el-button>
						<!-- <el-button v-if="isAdmin" class="fr" type="primary" size="small">下载</el-button> -->
						<!-- <el-button class="fr" type="primary" size="small">上传文件</el-button> -->
						<!-- <upload-hide accept="*" :fileLimit="10" @successUpload="successUpload"></upload-hide> -->
						<uploader
							:multiple="false"
							accept="*"
							listType="text"
							:maxSize="1 * 1024 * 1024 * 1024"
							:file-list.sync="fileList"
							@uploaded="successUpload"
						/>
					</div>
					<el-table
						element-loading-text="拼命加载中..."
						element-loading-spinner="el-icon-loading"
						element-loading-background="rgba(255, 255, 255, 0.9)"
						row-key="id"
						:data="tableData"
						stripe
						style="width: 100%"
						:header-cell-style="{ background: '#EFEFEF' }"
						@selection-change="handleSelectionChange"
					>
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column prop="attachType" label="文件类型" width="120">
							<template slot-scope="scope">
								<el-tooltip class="item" effect="dark" content="预览" placement="top-start">
									<i
										class="file-type"
										:class="mapFileIcon(scope.row.attachType)"
										@click="lookFile(scope.row.attachUrl)"
									></i>
								</el-tooltip>
							</template>
						</el-table-column>
						<el-table-column prop="attachName" width="160" label="文件名称"></el-table-column>
						<el-table-column prop="userName" label="上传教师" width="120"></el-table-column>
						<el-table-column prop="userCode" label="师训号" width="120"></el-table-column>
						<el-table-column prop="schoolName" label="所属校区"></el-table-column>
						<el-table-column prop="score" label="分数"></el-table-column>
						<el-table-column prop="createTime" label="时间" width="180"></el-table-column>
						<el-table-column label="操作" width="180">
							<template slot-scope="scope">
								<el-button type="text" @click="lookFile(scope.row.attachUrl)">预览</el-button>
								<el-button
									type="text"
									v-if="scope.row.createBy == userInfo.userId"
									class="ml del-btn"
									@click="delPop(scope.row)"
								>删除</el-button>
							</template>
						</el-table-column>
					</el-table>
					<pagination
						:pageObj="pageObj"
						@handleSizeChange="handleSizeChange"
						@handleCurrentChange="handleCurrentChange"
					></pagination>
				</template>
			</tpl-detail>
		</div>
		<el-dialog title="评价" :visible.sync="showEvaPop" width="500px">
			<el-form :model="form" :rules="rules" ref="form">
				<el-form-item label="分数" size="small" prop="score">
					<el-input-number
						v-model="form.score"
						validate-event
						autocomplete="on"
						type="number"
						:min="1"
						:max="100"
					></el-input-number>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="subEva" size="small">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 删除的对话框 -->
		<popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>
		<!-- 导出的execl -->
		<el-table
			v-show="false"
			id="downlaodId"
			element-loading-text="拼命加载中..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(255, 255, 255, 0.9)"
			row-key="id"
			:data="tableDataAll"
			stripe
			style="width: 100%"
			:header-cell-style="{ background: '#EFEFEF' }"
		>
			<el-table-column prop="attachName" width="160" label="文件名称"></el-table-column>
			<el-table-column prop="userName" label="上传教师" width="120"></el-table-column>
			<el-table-column prop="userCode" label="师训号" width="120"></el-table-column>
			<el-table-column prop="schoolName" label="所属校区"></el-table-column>
			<el-table-column prop="score" label="分数"></el-table-column>
			<el-table-column prop="createTime" label="时间" width="180"></el-table-column>
		</el-table>
	</div>
</template>
<script>
import PopupDel from "@/components/PopupDel.vue";
import uploader from "@/components/school/uploader.vue";
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import Pagination from "@/components/Pagination.vue";
import { mapState } from "vuex";
import { mapFileIcon, lookFile, downlaodHandler } from "@/utils/index.js";
export default {
	components: {
		TplDetail,
		uploader,
		Pagination,
		PopupDel
	},
	props: {
		linkInfo: {
			type: Object
		}
	},
	computed: {
		...mapState(["userInfo", "isAdmin"])
	},
	data() {
		return {
			searchKeyWord: "",
			pageObj: {
				current: 1,
				total: 0,
				size: 10,
				sizeList: [5, 10, 15, 20]
			},
			fileList: [],
			tableData: [],
			tableDataAll: [], //导出全部的表格
			idArr: [],
			delId: "",
			showEvaPop: false,
			delVisible: false,
			curId: "",
			form: {
				score: 100
			},
			rules: {
				score: [{ required: true, message: "请输入分数", trigger: "blur" }]
			}
		};
	},

	created() {
		this.init();
	},
	methods: {
		mapFileIcon,
		lookFile,
		init() {
			this.selectData();
		},
		async selectData() {
			let { records, total } = await postJson("/node/getNodeTopicHomework", {
				actCode: this.linkInfo.actCode,
				nodeCode: this.linkInfo.nodeCode,
				operatorId: this.userInfo.userId,
				isAdmin: this.isAdmin ? 1 : 0,
				keyword: this.searchKeyWord,
				pageSize: this.pageObj.size,
				pageNum: this.pageObj.current
			});
			this.tableData = records;
			this.pageObj.total = total;
		},
		handleSelectionChange(val) {
			this.idArr = val.map(i => i.id);
		},
    async successUpload(params) {

			const { response, file, fileList } = params
			let paramObj = Object.assign(fileList[0], {
				actCode: this.linkInfo.actCode,
				nodeCode: this.linkInfo.nodeCode,
				operatorId: this.userInfo.userId,
				schoolCode: this.userInfo.schoolCode
			});
			await postJson("/node/saveNodeTopicHomework", paramObj);
			this.fileList=[]
			this.selectData();
		},
		//分页
		handleSizeChange(pageSize) {
			this.pageObj.current = 1;
			this.pageObj.size = pageSize;
			this.selectData();
		},
		handleCurrentChange(curPage) {
			this.pageObj.current = curPage;
			this.selectData();
		},
		evaPop() {
			if (this.idArr.length < 1) {
				this.$message.error("请先勾选需要评价的作业！");
			} else {
				this.showEvaPop=100;
				this.showEvaPop = true;
			}
		},
		async subEva() {
			await this.$refs.form.validate();
			await postJson("/node/batchUpdateHomework", {
				nodeCode: this.linkInfo.nodeCode,
				actCode: this.linkInfo.actCode,
				ids: this.idArr,
				operatorId: this.userInfo.userId,
				score: this.form.score
			});
			this.selectData();
			this.$message.success("评价成功！");
			this.showEvaPop = false;
		},
		delPop(row) {
			this.delId = row.id;
			this.delVisible = true;
		},
		// 删除弹框 关闭
		async closePopupDel(status) {
			try {
				if (status) {
					await postData("/node/deleteNodeTopicHomework", { id: this.delId });
					this.$message({
						message: "删除成功",
						type: "success",
						duration: 2000,
						offset: 150
					});
					this.selectData();
					this.delVisible = false;
				} else {
					this.delVisible = false;
				}
			} catch (err) {
				console.log("err", err);
			}
		},
		downlaodExecl() {
			postJson("/node/getNodeTopicHomework", {
				actCode: this.linkInfo.actCode,
				nodeCode: this.linkInfo.nodeCode,
				operatorId: this.userInfo.userId,
				isAdmin: this.isAdmin ? 1 : 0,
				keyword: "",
				pageSize: -1,
				pageNum: 1
			}).then(res => {
				this.tableDataAll = res.records
				this.$nextTick(() => {
					downlaodHandler("#downlaodId", "培训作业明细表");
				});
			});

		}
	},
	watch: {}
};
</script>
<style lang="less" scoped>
.link-work {
	.do-box {
		margin-bottom: 10px;
		.el-button {
			margin-left: 25px;
		}
	}
	.file-type {
		cursor: pointer;
		font-size: 24px;
		color: @color;
	}
	.ml {
		margin-left: 30px;
	}
	.del-btn {
		color: @hong;
	}
}
</style>
